import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Inject,
} from '@angular/core';

import { IAccount } from '@account-users/account/models/IAccount';
import { AccountCategory } from '@account-users/account/models/AccountCategory';

@Component({
  selector: 'app-user-account-preview',
  templateUrl: './user-account-preview.component.html',
  styleUrls: ['./user-account-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserAccountPreviewComponent {
  @Input() account: IAccount;
  @Input() userName: string;
  @Input() userId: string;
  @Input() showGoToAccountLink = false;
  @Input() accountCategories: AccountCategory[] = [];

  constructor(@Inject('oneUrl') private oneUrl: string) {}

  goToOneAsStaffUser() {
    window.open(`${this.oneUrl}?accountId=${this.account.id}`);
  }

  accountCategoriesMap(categoryCode) {
    const accountCategory = this.accountCategories.find(
      (ac) => ac.code === categoryCode,
    );
    return accountCategory ? accountCategory.displayName : '';
  }
}
